import React, { useEffect, useState } from "react";
import api from '../utils/api';
import constants from "../lib/constants";
import OverlayLoader from "../lib/components/OverlayLoader";

const Payouts = () => {
    const [payoutsList, updatePayoutsList] = useState([]);
    const [total, updateTotal] = useState(0);
    const [loadingOverlay, updateLoadingOverlay] = useState(true);
    const [isError, updateIsError] = useState(false);
    const [selectedYear, updateSelectedYear] = useState(constants.currentSeason);

    const retrievePayouts = (year) => {
        updateLoadingOverlay(true);
        updateIsError(false);
        api.get(`api/v1/history/payouts/year/${year}`).then(({ data }) => {
            updatePayoutsList(data);
            updateTotal(data.reduce((acc, cur) => acc + cur.payout, 0));
        }).catch((err) => {
            console.error(`Failed to get payouts, ${err}`);
            updateIsError(true);
        }).finally(() => {
            updateLoadingOverlay(false);
        });
    };

    const deletePayoutOption = (id) => {
        updateLoadingOverlay(true);
        api.delete(`api/v1/history/payouts/year/${selectedYear}/${id}`).then(() => {
            alert('Payout Deleted!');
        }
        ).catch((err) => {
            alert(`Failed to delete payout, ${err}`);
        }).finally(() => {
            updateLoadingOverlay(false);
            retrievePayouts(selectedYear);
        });
    };

    useEffect(() => {
        retrievePayouts(selectedYear);        
    }, [selectedYear]);

    return (
        <div>
            {loadingOverlay ? <OverlayLoader/> : null}
            <select value={selectedYear} onChange={(e) => updateSelectedYear(e.target.value)} className="form-select">
                {constants.eligablePayoutYears.map((year) => (
                    <option key={year} value={year}>{year}</option>
                ))}
            </select>
            {isError ? <div>Error loading payouts!</div> : 
                <div>
                    <table className="table table-striped">
                        <tbody>
                            {payoutsList.map(payout => {
                                return (
                                    <tr key={`${payout.id}`}>
                                        <td>{payout.type}</td>
                                        <td>{payout.payout}</td>
                                        <td>{payout.manager}</td>
                                        <td>{payout.winner}</td>
                                        <td>
                                            <button className="btn btn-danger" onClick={() => deletePayoutOption(payout.id)}>
                                                <i className="bi bi-x-circle-fill"/>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                            <AddPayoutRow 
                                updateLoadingOverlay={updateLoadingOverlay} 
                                retrievePayouts={() => retrievePayouts(selectedYear)} 
                                selectedYear={selectedYear}
                            />
                            <tr key='totals'>
                                <td>Totals</td>
                                <td></td>
                                <td>{total}</td>
                                <td></td>
                                <td>Buy in: {total / 12}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}

const AddPayoutRow = ({ updateLoadingOverlay, retrievePayouts, selectedYear }) => {
    const payoutOptionsDefault = {
        type: '',
        payout: 10,
        manager: constants.managerList[0],
        winner: ''
    };
    const [addPayoutOptions, updateAddPayoutOptions] = useState(payoutOptionsDefault);
    const addPayout = () => {
        updateLoadingOverlay(true);
        api.post(`api/v1/history/payouts/year/${selectedYear}`, addPayoutOptions).then(() => {
            alert('Payout Added!');
            updateAddPayoutOptions(payoutOptionsDefault);
        }).catch((err) => {
            alert(`Failed to add payout, ${err}`);
        }).finally(() => {
            updateLoadingOverlay(false);
            retrievePayouts();
        });
    };

    const updatePayoutType = (e) => {
        updateAddPayoutOptions({ ...addPayoutOptions, type: e.target.value });
    };
    const updatePayoutAmount = (e) => {
        updateAddPayoutOptions({ ...addPayoutOptions, payout: e.target.value });
    };
    const updatePayoutManager = (e) => {
        updateAddPayoutOptions({ ...addPayoutOptions, manager: e.target.value });
    };
    const updatePayoutWinner = (e) => {
        updateAddPayoutOptions({ ...addPayoutOptions, winner: e.target.value });
    };
    return (
        <tr>
            <td><button className="btn btn-primary" onClick={addPayout}><i className="bi bi-save"></i></button></td>
            <td><input type="text" className="form-control" placeholder="Ex. Week 1 Power Rankings" onChange={updatePayoutType}/></td>
            <td><input type="number" className="form-control" placeholder="10" onChange={updatePayoutAmount}/></td>
            <td><select className="form-select" onChange={updatePayoutManager}>{constants.managerList.map((manager) => (
                <option>{manager}</option>
            ))}</select></td>
            <td><input type="text" className="form-control" placeholder="Winner" onChange={updatePayoutWinner}/></td>
        </tr>
    )
}

export default Payouts;
